var map = {
	"./100-mil-book-aus.svg": 219,
	"./100-mil-book-es.svg": 220,
	"./100-mil-book.svg": 221,
	"./3000-outlets-aus.svg": 222,
	"./3000-outlets-es.svg": 223,
	"./3000-outlets.svg": 224,
	"./50-countries-aus.svg": 225,
	"./50-countries-es.svg": 226,
	"./50-countries.svg": 227,
	"./70-mil-authors-aus.svg": 228,
	"./70-mil-authors-es.svg": 229,
	"./70-mil-authors.svg": 230,
	"./Componente 6 – 2.svg": 231,
	"./Componente 7 – 2.svg": 232,
	"./Componente 8 – 2.svg": 233,
	"./Google_Play.svg": 234,
	"./Logo_ESP_BRANCO.png": 235,
	"./Logo_ESP_ROXO.png": 236,
	"./a4-white.svg": 237,
	"./a4.svg": 238,
	"./a5-white.svg": 239,
	"./a5.svg": 240,
	"./after-01.png": 241,
	"./after-02.png": 242,
	"./after-03.png": 243,
	"./agbook-logo-editor-load.jpg": 244,
	"./agbook-logo-mobile-2.jpg": 245,
	"./agbook-logo-mobile.png": 142,
	"./agbook-logo.png": 246,
	"./ajustes2.png": 247,
	"./alphagraphics.svg": 248,
	"./amex.svg": 249,
	"./arquivo2.png": 250,
	"./authorfreely_primarylogo.png": 128,
	"./avaliacao2.png": 251,
	"./background-service-all.png": 252,
	"./background-stores.jpg": 253,
	"./banner_partner_stores.png": 254,
	"./bb.svg": 255,
	"./blogger-round-svgrepo-com.svg": 256,
	"./bok2-logo-min.png": 257,
	"./boleto.svg": 258,
	"./book-1-translation.png": 259,
	"./book-1.png": 260,
	"./book-2.png": 261,
	"./book-3.png": 262,
	"./book-old.png": 263,
	"./book-type-orange.svg": 264,
	"./book-type-red.svg": 265,
	"./book-type.png": 266,
	"./book-type.svg": 267,
	"./book-upload-icon.svg": 268,
	"./book.png": 269,
	"./bottom-background.png": 270,
	"./bradesco.svg": 271,
	"./brand-tiktok-svgrepo-com.svg": 272,
	"./card-icon-1.svg": 273,
	"./card-icon-2.svg": 274,
	"./card-icon-3.svg": 275,
	"./card-icon-4.svg": 276,
	"./card.svg": 277,
	"./chevron-right-black.svg": 278,
	"./chevron-right.svg": 279,
	"./close.svg": 280,
	"./clube-icon-decorator.png": 281,
	"./completed-purchase-book-aus.png": 282,
	"./completed-purchase-book.png": 283,
	"./congratulations-aus.png": 284,
	"./correcoes2.png": 285,
	"./cover-revision.png": 286,
	"./creditcard.png": 287,
	"./cta-desktop-en.png": 288,
	"./cta-desktop-red.png": 289,
	"./cta-desktop.png": 290,
	"./cta-desktop_es.jpg": 291,
	"./cta-mobile-en.png": 292,
	"./cta-mobile-red.png": 293,
	"./cta-mobile.png": 294,
	"./cta-mobile_es.jpg": 295,
	"./diners.svg": 296,
	"./divulgacao2.png": 297,
	"./esboco.png": 298,
	"./esboco.svg": 299,
	"./facebook-share-pink.svg": 300,
	"./facebook.svg": 301,
	"./first-circle.svg": 302,
	"./frete-gratis.png": 303,
	"./hand-intelligent.png": 304,
	"./happy-man-using-his-tablet-home-couch_1.png": 305,
	"./happy-man-using-his-tablet-home-couch_2.png": 306,
	"./happy-man-using-his-tablet-home-couch_3.png": 307,
	"./happy-man-using-his-tablet-home-couch_4.png": 308,
	"./hero-background-mobile.png": 309,
	"./hero-background.png": 310,
	"./hero-book-image.png": 311,
	"./hipercard.svg": 312,
	"./icon-a4.svg": 313,
	"./icon-a5.svg": 314,
	"./icon-add.svg": 315,
	"./icon-amazon.svg": 316,
	"./icon-americanas.svg": 317,
	"./icon-apple.svg": 318,
	"./icon-arrow-down-grey.svg": 319,
	"./icon-arrow-down-purple-green.svg": 320,
	"./icon-arrow-down-purple-orange.svg": 321,
	"./icon-arrow-down-purple-white.svg": 322,
	"./icon-arrow-down-purple.svg": 323,
	"./icon-arrow-left-pagination.svg": 324,
	"./icon-arrow-right-orange.svg": 325,
	"./icon-arrow-right-pagination.svg": 326,
	"./icon-arrow-right-pink.svg": 327,
	"./icon-arrow-right-white.svg": 328,
	"./icon-book-grey.svg": 329,
	"./icon-book-orange.svg": 330,
	"./icon-book-purple.svg": 331,
	"./icon-book-white.svg": 332,
	"./icon-burger-purple.svg": 333,
	"./icon-burger-white.svg": 334,
	"./icon-camera.svg": 335,
	"./icon-cart-grey.svg": 336,
	"./icon-cart-white.svg": 337,
	"./icon-chat-orange.svg": 338,
	"./icon-chat-red.svg": 339,
	"./icon-chat.svg": 340,
	"./icon-check-green.svg": 341,
	"./icon-check-pink.svg": 342,
	"./icon-check-red.svg": 343,
	"./icon-check-white.svg": 344,
	"./icon-chevron_left-orange.svg": 345,
	"./icon-chevron_left-red.svg": 346,
	"./icon-chevron_left.svg": 347,
	"./icon-chevron_right.svg": 348,
	"./icon-close-quote.svg": 349,
	"./icon-cross-purple.svg": 350,
	"./icon-cross-red.svg": 351,
	"./icon-cross-white.svg": 352,
	"./icon-donthave.svg": 353,
	"./icon-download.svg": 354,
	"./icon-ebook-orange.svg": 355,
	"./icon-ebook.svg": 356,
	"./icon-epub.svg": 357,
	"./icon-estantevirtual.svg": 358,
	"./icon-exit-aila-editor.svg": 359,
	"./icon-export.svg": 360,
	"./icon-external.svg": 361,
	"./icon-facebook-purple.svg": 362,
	"./icon-feature-detail.svg": 363,
	"./icon-full-cover.svg": 364,
	"./icon-globe.png": 365,
	"./icon-googleplay.svg": 366,
	"./icon-has.svg": 367,
	"./icon-hasnt.svg": 368,
	"./icon-have.svg": 369,
	"./icon-header-aila-editor.svg": 370,
	"./icon-image-gallery.svg": 371,
	"./icon-image-upload.svg": 372,
	"./icon-livrariacultura.svg": 373,
	"./icon-logo-blog-white.svg": 374,
	"./icon-lp-1-orange.svg": 375,
	"./icon-lp-1-red.svg": 376,
	"./icon-lp-1.svg": 377,
	"./icon-lp-2-orange.svg": 378,
	"./icon-lp-2-red.svg": 379,
	"./icon-lp-2.svg": 380,
	"./icon-lp-3-red.svg": 381,
	"./icon-lp-3.svg": 382,
	"./icon-mercadolivre.svg": 383,
	"./icon-mini-book-orange.svg": 384,
	"./icon-mini-book.svg": 385,
	"./icon-money-orange.svg": 386,
	"./icon-money-purple.svg": 387,
	"./icon-open-chart-orange.svg": 388,
	"./icon-open-chart.svg": 389,
	"./icon-open-quote.svg": 390,
	"./icon-person-grey.svg": 391,
	"./icon-person-white.svg": 392,
	"./icon-play-two.svg": 393,
	"./icon-play.svg": 394,
	"./icon-pocket.svg": 395,
	"./icon-print-orange.svg": 396,
	"./icon-print.svg": 397,
	"./icon-profile-orange.svg": 398,
	"./icon-profile-red.svg": 399,
	"./icon-profile.svg": 400,
	"./icon-quadrado.svg": 401,
	"./icon-questionmark-orange.svg": 402,
	"./icon-questionmark-red.svg": 403,
	"./icon-questionmark.svg": 404,
	"./icon-rakuten.svg": 405,
	"./icon-search-purple-orange.svg": 406,
	"./icon-search-purple.svg": 407,
	"./icon-select-arrow.svg": 408,
	"./icon-separated-cover.svg": 409,
	"./icon-seu-livro-bok2.png": 410,
	"./icon-seu-livro-red.png": 411,
	"./icon-seu-livro.png": 412,
	"./icon-speak-orange.svg": 413,
	"./icon-speak-purple.svg": 414,
	"./icon-submarino.svg": 415,
	"./icon-trash-can.svg": 416,
	"./icon-trash.svg": 417,
	"./icon-tu-libro.png": 418,
	"./icon-twitter-purple.svg": 419,
	"./icon-upload-white.svg": 420,
	"./icon-upload.svg": 421,
	"./icon_linkedin.svg": 422,
	"./icons8-check.gif": 423,
	"./idioma-33.png": 424,
	"./img-footer-bok2.svg": 425,
	"./img-footer-es.svg": 426,
	"./img-footer.svg": 427,
	"./img2-footer-aus.svg": 428,
	"./img2-footer-es.svg": 429,
	"./img2-footer.svg": 430,
	"./info-orange.svg": 431,
	"./info-pink.svg": 432,
	"./info-red.svg": 433,
	"./info.svg": 434,
	"./info1.jpg": 435,
	"./info2.jpg": 436,
	"./info3.jpg": 437,
	"./instagram-share-pink.svg": 438,
	"./instagram.svg": 439,
	"./itau.svg": 440,
	"./laptop-cda.png": 441,
	"./linkedin.svg": 442,
	"./lock.svg": 443,
	"./logo-amazon-color.png": 444,
	"./logo-amazon.png": 445,
	"./logo-americanas-color.png": 446,
	"./logo-americanas.png": 447,
	"./logo-apple-color.png": 448,
	"./logo-apple.png": 449,
	"./logo-authorfreely-mobile.png": 129,
	"./logo-cda-mobile.svg": 450,
	"./logo-cda.svg": 451,
	"./logo-club-de-autores.png": 452,
	"./logo-clube-de-autores-share.png": 453,
	"./logo-clube-de-autores-share.svg": 454,
	"./logo-clube-de-autores.svg": 455,
	"./logo-cultura-color.png": 456,
	"./logo-cultura.png": 457,
	"./logo-estante-color.png": 458,
	"./logo-estante.png": 459,
	"./logo-google-color.png": 460,
	"./logo-google.png": 461,
	"./logo-mercado-color.png": 462,
	"./logo-mercado.png": 463,
	"./logo-rakuten-color.png": 464,
	"./logo-rakuten.png": 465,
	"./logo-submarino-color.png": 466,
	"./logo-submarino.png": 467,
	"./lp-banner-a-desktop.png": 468,
	"./lp-banner-a-mobile.png": 469,
	"./lp-banner-b-desktop-red.png": 470,
	"./lp-banner-b-desktop.png": 471,
	"./lp-banner-b-mobile-red.png": 472,
	"./lp-banner-b-mobile.png": 473,
	"./mastercard.svg": 474,
	"./medium-shot-excited-woman-with-laptop-2.png": 475,
	"./medium-shot-excited-woman-with-laptop.png": 476,
	"./new-icon-facebook.svg": 477,
	"./new-icon-linkedin.svg": 478,
	"./new-icon-twitter.svg": 479,
	"./norton.svg": 480,
	"./nota-final2.png": 481,
	"./pix.png": 482,
	"./pocket-white.svg": 483,
	"./pocket.svg": 484,
	"./preco2.png": 485,
	"./privacidade2.png": 486,
	"./publico2.png": 487,
	"./publish-book.png": 488,
	"./publish-book_agbook-2.png": 489,
	"./publish-book_agbook.png": 490,
	"./publish-book_en.png": 491,
	"./publish-book_es.png": 492,
	"./quadrado-white.svg": 493,
	"./quadrado.svg": 494,
	"./relatorio2.png": 495,
	"./responsabilidade.png": 496,
	"./room-circle.svg": 497,
	"./second-circle.svg": 498,
	"./slider-arrow-left-grey.svg": 499,
	"./slider-arrow-right-grey.svg": 500,
	"./stars_1-orange.svg": 501,
	"./stars_1-red.svg": 502,
	"./stars_1.svg": 503,
	"./stars_2-orange.svg": 504,
	"./stars_2-red.svg": 505,
	"./stars_2.svg": 506,
	"./stars_3-orange.svg": 507,
	"./stars_3-red.svg": 508,
	"./stars_3.svg": 509,
	"./stars_4-orange.svg": 510,
	"./stars_4-red.svg": 511,
	"./stars_4.svg": 512,
	"./stars_5-orange.svg": 513,
	"./stars_5-red.svg": 514,
	"./stars_5.svg": 515,
	"./stars_sprint.png": 516,
	"./stars_sprint.svg": 517,
	"./stars_sprint_orange.svg": 518,
	"./stars_sprint_red.svg": 519,
	"./third-circle.svg": 520,
	"./twitter-share-pink.svg": 521,
	"./twitter.svg": 522,
	"./user-account-en.png": 523,
	"./user-book.png": 524,
	"./visa.svg": 525,
	"./whatsapp.svg": 526,
	"./word-file-icon.svg": 527,
	"./word-message-aus.svg": 528,
	"./word-message-es.svg": 529,
	"./word-message.svg": 530,
	"./wordpress.svg": 531,
	"./your-book-mini-aus.png": 532,
	"./youtube-play-svgrepo-com.svg": 533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 218;